import { lazy } from 'react';

export const PlayerVerifySourceOfWealthForm = lazy(
  () => import('./PlayerVerifySourceOfWealthForm'),
);
